import React from 'react'

export const Skeleton = ({ className = '', style }) => (
  <div
    className={`animate-pulse rounded bg-line ${className}`}
    style={style}
  />
)

export const SummarySkeleton = () => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
    {[0, 1, 2, 3].map((i) => (
      <div
        key={i}
        className="rounded-card px-4 py-4 flex flex-col justify-between gap-4 border border-line bg-white shadow-card"
      >
        <div className="flex items-start gap-3">
          <Skeleton className="h-10 w-10 flex-none rounded-xl" />
          <div className="flex-1">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="mt-2 h-7 w-20" />
          </div>
        </div>
        <div className="border-t border-line pt-3 flex items-center justify-between">
          <Skeleton className="h-3 w-28" />
          <Skeleton className="h-3 w-8" />
        </div>
      </div>
    ))}
  </div>
)

export const TableSkeletonRows = ({ rows = 5, columns = 5 }) => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <tr key={rowIndex}>
        {Array.from({ length: columns }).map((_, colIndex) => (
          <td key={colIndex}>
            <Skeleton className="h-4 w-full min-w-[64px]" />
          </td>
        ))}
      </tr>
    ))}
  </>
)

export const ChartSkeleton = ({ className = '' }) => (
  <div className={`flex items-end gap-3 ${className}`}>
    {[60, 85, 45, 70, 95, 55, 75, 40, 65, 80].map((height, i) => (
      <Skeleton key={i} className="flex-1" style={{ height: `${height}%` }} />
    ))}
  </div>
)

export default Skeleton
